import { Overlay } from "ol";
import OverlayPositioning from "ol/OverlayPositioning";
export class Tooltip {
    constructor(feature) {
        this.active = true;
        this.feature = feature;
        this.element = $("<div></div>");
        this.element.css('z-index', 1000000);
        this.element.addClass('ol-tooltip ol-tooltip-measure');
        this.overlay = new Overlay({
            element: this.element.get(0),
            offset: [0, -25],
            positioning: OverlayPositioning.BOTTOM_CENTER
        });
    }
    update_position(coord) {
        this.overlay.setPosition(coord);
    }
    update_text(new_text) {
        this.element.html(new_text);
    }
    make_static(layer) {
        this.element.addClass('ol-tooltip ol-tooltip-static');
        this.overlay.setOffset([0, -7]);
        this.element.on('contextmenu', (evt) => {
            evt.preventDefault();
            this.remove_from(layer);
        });
    }
    remove_from(layer) {
        var _a;
        if (!this.active)
            return;
        this.element.remove();
        if (layer.source.hasFeature(this.feature))
            layer.source.removeFeature(this.feature);
        (_a = this.overlay.getMap()) === null || _a === void 0 ? void 0 : _a.removeOverlay(this.overlay);
        this.active = false;
    }
}
